export const TARGET_CATEGORY_NAMES = ["Forecast", "Plan", "Budget"] as const; // TODO: add "Actuals"?

export type TargetCategoryName = (typeof TARGET_CATEGORY_NAMES)[number];

export const isTargetCategoryName = (value: string | null): value is TargetCategoryName =>
  value !== null && (TARGET_CATEGORY_NAMES as readonly string[]).includes(value);
